import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Section } from './Section';
import { transformacion } from '../data/comparativas';
export function Transformation() {
  return <Section tone="white" data-id="element-236" data-mp="mme570makwts">
      <h2 className="text-center font-serif text-[28px] leading-tight sm:text-4xl" data-id="element-237" data-mp="ml32730o7t3q">
        De improvisar a dirigir el evento
      </h2>

      <div className="mt-12 hidden grid-cols-2 gap-x-8 md:grid" data-id="element-238" data-mp="rj4kvmu6pqeo">
        <p className="pb-4 text-[11px] uppercase tracking-[0.18em] text-ink-muted" data-id="element-239" data-mp="wjiw1dr31ggx">
          Antes, sin sistema
        </p>
        <p className="pb-4 text-[11px] uppercase tracking-[0.18em] text-gold" data-id="element-240" data-mp="11hkgo345pnui">
          Con el Master Plan 15
        </p>
      </div>

      <ul className="mt-8 flex flex-col gap-4 md:mt-0 md:gap-0" data-id="element-241" data-mp="1abgzb7y44i56">
        {transformacion.map(row => <li key={row.after} className="grid gap-3 md:grid-cols-2 md:gap-x-8 md:border-t md:border-gold-line md:py-6" data-id="element-242" data-mp="1fbbpf9a2d3p6">
            <div className="flex items-start gap-3 rounded-card bg-blush-soft p-4 md:bg-transparent md:p-0" data-id="element-243" data-mp="1ka65i3gnce5l">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-blush-ink" strokeWidth={2.5} aria-hidden="true" data-id="element-244" data-mp="1c3xilf4bbiox" />
              <p className="text-[15px] leading-relaxed text-blush-ink md:text-ink-muted" data-id="element-245" data-mp="135vj54088y3r">
                <span className="mb-1 block text-[10px] uppercase tracking-[0.18em] text-blush-ink/70 md:hidden" data-id="element-246" data-mp="y7k84py74hjy">
                  Antes, sin sistema
                </span>
                {row.before}
              </p>
            </div>

            <div className="flex items-start gap-3 rounded-card border border-gold-line p-4 md:border-0 md:p-0" data-id="element-247" data-mp="1qxafmg5bol73">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-248" data-mp="1h54r5gea4lwn" />
              <p className="text-[15px] font-medium leading-relaxed text-ink" data-id="element-249" data-mp="2emlic368gpnv">
                <span className="mb-1 block text-[10px] font-semibold uppercase tracking-[0.18em] text-gold md:hidden" data-id="element-250" data-mp="29s7klu43m6g1">
                  Con el Master Plan 15
                </span>
                {row.after}
              </p>
            </div>
          </li>)}
      </ul>
    </Section>;
}